import styled from '../../../../../theme'

const ClickAwayBackground = styled.div`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: -1;
`

export default ClickAwayBackground
